import type { Dictionary } from './en'
import { storeHi } from './store.hi'
import { v1PackHi } from './v1-pack.hi'
import { v1GateProcessHi } from './v1-gate-process.hi'
import { v1StockHi } from './v1-stock.hi'
import { v1MoveCountHi } from './v1-move-count.hi'
import { gateHi } from './gate.hi'
import { processHi } from './process.hi'
import { packHi } from './pack.hi'
import { passportHi } from './passport.hi'

/** Hindi messages. The type forces every English key to have a Hindi string. */
export const hi: Dictionary = {
  // F5 store phone flows (store.hi.ts)
  ...storeHi,
  ...v1PackHi,
  ...v1GateProcessHi,
  ...v1StockHi,
  ...v1MoveCountHi,
  // F4 gate phone flows (gate.hi.ts)
  ...gateHi,
  ...processHi,
  ...packHi,
  ...passportHi,
  'common.appName': 'अनकम्प्रोमाइज़्ड',
  'common.back': 'वापस',
  'common.cancel': 'रद्द करें',
  'common.close': 'बंद करें',
  'common.confirm': 'पक्का करें',
  'common.continue': 'आगे बढ़ें',
  'common.done': 'हो गया',
  'common.retry': 'फिर कोशिश करें',
  'common.save': 'सेव करें',
  'common.search': 'खोजें',
  'common.loading': 'लोड हो रहा है…',
  'boot.stuck.title': 'ऐप खुलते-खुलते अटक गया है',
  'boot.stuck.body': 'आपका काम इस फ़ोन में सुरक्षित है। ब्राउज़र ऐप को जवाब नहीं दे रहा। यह करें:',
  'boot.stuck.step1': 'इस ब्राउज़र में farmgate के बाकी सभी टैब बंद करें।',
  'boot.stuck.step2':
    'ब्राउज़र को पूरा बंद करें (हाल के ऐप्स से हटा दें), फिर farmgate दोबारा खोलें।',
  'boot.stuck.step3': 'फिर भी अटका है? फ़ोन बंद करके चालू करें।',
  'boot.stuck.warning': 'ब्राउज़र का डेटा या हिस्ट्री साफ़ न करें: न भेजा गया काम मिट जाएगा।',
  'common.optional': 'ज़रूरी नहीं',
  'common.required': 'ज़रूरी',
  'common.language': 'भाषा',
  'common.offline': 'ऑफ़लाइन',
  'common.online': 'ऑनलाइन',
  'common.youAreOffline': 'नेटवर्क नहीं है। काम फ़ोन में सेव है, नेटवर्क आने पर भेजा जाएगा।',
  'common.comingSoon': 'यह स्क्रीन बन रही है।',
  'common.notFound': 'पेज नहीं मिला',
  'common.notFoundBody': 'यह पेज मौजूद नहीं है या हट गया है।',
  'common.goHome': 'होम पर जाएँ',
  'common.somethingWrong': 'कुछ गड़बड़ हुई',
  'common.somethingWrongBody':
    'स्क्रीन में गड़बड़ी हुई। आपका सेव किया काम इस फ़ोन में सुरक्षित है।',
  'common.reload': 'फिर से खोलें',
  'common.noResults': 'खोज से कुछ नहीं मिला।',
  'common.page': 'पेज {page} / {pages}',
  'common.previous': 'पिछला',
  'common.next': 'अगला',
  'common.rows': '{count} {count:पंक्ति|पंक्तियाँ}',
  'common.step': 'चरण {current} / {total}',

  'pwa.updateTitle': 'नया वर्ज़न तैयार है',
  'pwa.updateBody': 'इस्तेमाल के लिए फिर से खोलें। बिना भेजा काम फ़ोन में रहेगा।',
  'pwa.updateAction': 'फिर से खोलें',
  'pwa.offlineReady': 'बिना नेटवर्क काम के लिए तैयार',
  'pwa.installTitle': 'इस फ़ोन पर इंस्टॉल करें',
  'pwa.installBody': 'पूरी स्क्रीन पर खुलेगा और बिना नेटवर्क चलेगा।',
  'pwa.installAction': 'इंस्टॉल करें',

  'auth.signIn': 'लॉगिन करें',
  'auth.signOut': 'लॉग आउट',
  'auth.identifier': 'ईमेल, फ़ोन या यूज़रनेम',
  'auth.password': 'पासवर्ड',
  'auth.showPassword': 'पासवर्ड दिखाएँ',
  'auth.hidePassword': 'पासवर्ड छुपाएँ',
  'auth.signInHint': 'ऑफ़िस से मिला खाता इस्तेमाल करें। लॉगिन के लिए नेटवर्क चाहिए।',
  'auth.invalid': 'ईमेल/फ़ोन या पासवर्ड गलत है।',
  'auth.inactive': 'यह खाता चालू नहीं है। ऑफ़िस से पूछें।',
  'auth.needsNetwork': 'लॉगिन के लिए नेटवर्क चाहिए। जहाँ सिग्नल हो वहाँ जाएँ।',
  'auth.forbidden': 'आपका खाता यह पेज नहीं खोल सकता।',
  'auth.sessionExpired': 'लॉगिन की अवधि ख़त्म हो गई। फिर से लॉगिन करें।',

  'pin.title': 'पिन से खोलें',
  'pin.who': 'कौन काम कर रहा है?',
  'pin.enter': 'अपना पिन डालें',
  'pin.wrong': 'पिन गलत है। {left} कोशिश बाकी।',
  'pin.lockedOut': 'बहुत बार गलत पिन। {seconds} सेकंड रुकें।',
  'pin.noTeam': 'इस फ़ोन पर अभी टीम नहीं है। पहले किसान सूची डाउनलोड करें।',
  'pin.noTeamSite': 'इस फ़ोन पर अभी टीम नहीं है। पहले गोदाम सूची डाउनलोड करें।',
  'pin.noPinSet': 'इनका पिन सेट नहीं है। पहले ऑनलाइन पिन सेट करें।',
  'pin.lock': 'लॉक करें',
  'pin.switchUser': 'व्यक्ति बदलें',
  'role.admin': 'एडमिन',
  'role.central_admin': 'मुख्य एडमिन',
  'role.supervisor': 'सुपरवाइज़र',
  'role.village_operator': 'ख़रीद ऑपरेटर',
  'role.store_keeper': 'स्टोर कीपर',
  'role.machine_operator': 'मशीन ऑपरेटर',
  'role.payments_approver': 'भुगतान मंज़ूर करने वाले',
  'role.quality_release': 'क्वालिटी रिलीज़',
  'theme.label': 'रंग-रूप',
  'theme.light': 'हल्का',
  'theme.dark': 'गहरा',
  'theme.system': 'फ़ोन जैसा',
  'auth.eyebrow': 'आपूर्ति',
  'a11y.dismiss': 'हटाएँ',
  'a11y.loading': 'लोड हो रहा है',
  'a11y.mainNav': 'मुख्य मेन्यू',
  'pin.delete': 'मिटाएँ',
  'pin.clear': 'साफ़ करें',

  'device.title': 'यह फ़ोन सेट करें',
  'device.body':
    'एक बार लॉगिन करें, फिर "यह फ़ोन सेट करें" दबाएँ: फ़ोन आपके गाँव से जुड़ जाएगा और किसान सूची आ जाएगी। उसके बाद सिर्फ़ पिन चाहिए।',
  'device.uid': 'फ़ोन कोड',
  'device.status': 'रजिस्ट्रेशन',
  'device.registered': 'रजिस्टर्ड',
  'device.demoOffline':
    'डेमो फ़ोन: इसकी सूची डेमो डेटा से है, सर्वर पर नहीं। दोबारा शुरू करने के लिए डेमो डेटा फिर से लोड करें।',
  'device.notRegistered': 'अभी सेट नहीं हुआ',
  'device.revoked': 'ऑफ़िस ने यह फ़ोन बंद कर दिया है। इसका डेटा मिटा दिया गया।',
  'device.check': 'यह फ़ोन सेट करें',
  'device.pickVillage': 'यह फ़ोन किस गाँव का है',
  'device.pickVillageHint':
    'यह फ़ोन किस गाँव का है? नीचे गाँव चुनें, फिर "यह फ़ोन सेट करें" दोबारा दबाएँ।',
  'device.rosterLabel': 'किसान सूची',
  'more.export': 'डेटा निकालें (ZIP)',
  'more.exporting': 'फ़ाइल बन रही है…',
  'more.exported': '{records} रिकॉर्ड, {drafts} अधूरे, {photos} फ़ोटो निकाले',
  'more.exportedUploaded': '{count} फ़ोटो पहले ही सर्वर पर हैं, फ़ाइल में नहीं।',
  'more.exportFailed': 'डेटा नहीं निकला',
  'device.downloadRoster': 'किसान सूची अपडेट करें',
  'device.rosterAge': 'किसान सूची {when} डाउनलोड हुई',
  'device.rosterNever': 'किसान सूची डाउनलोड नहीं हुई',
  'device.rosterStale': 'किसान सूची एक दिन से पुरानी है।',
  'device.rosterExpired': 'किसान सूची बहुत पुरानी है। नेटवर्क में अपडेट करें।',
  'device.rosterUpdated': 'किसान सूची अपडेट हो गई',
  'device.storeListLabel': 'गोदाम सूची',
  'device.downloadStoreList': 'गोदाम सूची अपडेट करें',
  'device.storeListUpdated': 'गोदाम सूची अपडेट हो गई',
  'device.storeListAge': 'गोदाम सूची {when} डाउनलोड हुई',
  'device.storeListNever': 'गोदाम सूची डाउनलोड नहीं हुई',
  'device.storeListStale': 'गोदाम सूची एक दिन से पुरानी है।',
  'device.storeListExpired': 'गोदाम सूची बहुत पुरानी है। नेटवर्क में अपडेट करें।',
  'device.team': 'टीम',
  'device.prefix': 'कोड प्रीफ़िक्स',
  'device.devSeed': 'डेमो डेटा लोड करें',

  'cmd.bind_machine_label': 'मशीन लेबल',
  'cmd.cancel_run': 'रन रद्द',
  'cmd.close_issue': 'निकासी बंद',
  'cmd.close_run': 'रन बंद',
  'cmd.close_session': 'दिन बंद',
  'cmd.add_bank_account': 'बैंक खाता (बिना नेटवर्क सहेजा)',
  'cmd.commit_delivery': 'ख़रीद',
  'cmd.confirm_cleanout': 'सफ़ाई पूरी',
  'cmd.confirm_roll': 'रोल पक्का',
  'cmd.correct_run': 'रन में सुधार',
  'cmd.decide_run': 'रन पर फ़ैसला',
  'cmd.count_bay': 'खाने की गिनती',
  'cmd.dispatch_shipment': 'गाड़ी रवाना',
  'cmd.issue_to_run': 'रन को दिया',
  'cmd.load_bags': 'बोरियाँ लदीं',
  'cmd.mark_bags_conv': 'बोरियाँ लाल टाई',
  'cmd.move_bags': 'बोरियाँ हटाईं',
  'cmd.open_run': 'रन शुरू',
  'cmd.open_session': 'दिन शुरू',
  'cmd.pack_close': 'पैकिंग बंद',
  'cmd.put_away': 'जगह पर रखा',
  'cmd.receive_shipment': 'गाड़ी पहुँची',
  'cmd.record_output': 'माल तौला',
  'cmd.replace_container': 'बोरी बदली',
  'cmd.report_mixing': 'मिलावट की सूचना',
  'cmd.retag': 'नया टैग',
  'cmd.seal_sample': 'नमूना सील',
  'cmd.sign_bay_declaration': 'खाने की घोषणा',
  'cmd.spoil_slip': 'पर्ची ख़राब',
  'cmd.verify_pouch': 'पाउच जाँचा',
  'cmd.void_delivery': 'ख़रीद रद्द',
  'cmd.void_output': 'माल रद्द',
  'cmd.void_tag': 'टैग रद्द',
  'cmd.weigh_in': 'अंदर तौला',
  'cmd.weigh_pouches': 'पाउच तौले',
  'outbox.PENDING': 'बाकी',
  'outbox.SENDING': 'भेज रहे हैं',
  'outbox.APPLIED': 'पहुँच गया',
  'outbox.DUPLICATE': 'पहुँच गया',
  'outbox.HELD': 'ऑफ़िस में रुका',
  'outbox.WAIT_FOR_PARENT': 'पहले वाला काम बाकी',
  'outbox.ERROR': 'ध्यान दें',
  'sync.title': 'सिंक',
  'sync.now': 'अभी सिंक करें',
  'sync.pending': '{count} बाकी',
  'sync.allSynced': 'सब भेजा गया',
  'sync.syncing': 'भेज रहे हैं…',
  'sync.lastSynced': 'आख़िरी सिंक {when}',
  'sync.never': 'कभी सिंक नहीं हुआ',
  'sync.errors': '{count} पर ध्यान दें',
  'sync.held': '{count} ऑफ़िस में रुके हैं',
  'sync.signInNeeded': 'बाकी काम भेजने के लिए फिर से लॉगिन करें।',
  'sync.queueEmpty': 'भेजने को कुछ बाकी नहीं।',
  'sync.photos': '{count} फ़ोटो बाकी',
  'sync.statPending': 'बाकी',
  'sync.statHeld': 'रुके',
  'sync.statErrors': 'समस्या',
  'sync.statPhotos': 'फ़ोटो',
  'sync.statSent': 'पहुँचे',
  'sync.showAll': 'सब दिखाएँ',
  'sync.nothingHere': 'यहाँ कुछ नहीं।',
  'sync.exportAll': 'इस फ़ोन का सारा डेटा डाउनलोड करें (ZIP)',
  'sync.exporting': 'फ़ाइल बन रही है…',
  'sync.exported': 'सेव हुआ: {records} रिकॉर्ड, {photos} फ़ोटो',
  'sync.d.farmer': 'किसान',
  'sync.d.crop': 'फ़सल',
  'sync.d.lot': 'लॉट',
  'sync.d.bags': 'बोरियाँ',
  'sync.d.gross': 'कुल वज़न',
  'sync.d.net': 'शुद्ध वज़न',
  'sync.d.amount': 'रकम',
  'sync.d.moisture': 'नमी',
  'sync.d.slip': 'पर्ची नं.',
  'sync.d.reason': 'कारण',
  'sync.d.bagsShort': '{count} बोरी',
  'sync.d.photos': 'फ़ोटो {sent}/{total} गए',
  'sync.d.reached': 'सर्वर पर पहुँचा {when}',
  'sync.d.heldWhy': 'ऑफ़िस में रुका: {count} बात ऑफ़िस को देखनी है। फ़ोन पर कुछ नहीं करना।',
  'sync.d.share': 'टीम को भेजें',
  'sync.d.copied': 'कॉपी हो गया। टीम के लिए WhatsApp में चिपकाएँ।',
  'sync.d.allData': 'पूरा डेटा',
  'sync.d.hideData': 'डेटा छुपाएँ',
  'sync.p.SENT': 'गया',
  'sync.p.WAITING': 'बाकी',
  'sync.p.LOST': 'फ़ोन में खो गया',
  'sync.p.MISSING': 'फ़ोन पर नहीं',
  'sync.p.onServer': 'सर्वर पर है',
  'sync.p.noCopy': 'कॉपी नहीं',
  'sync.p.lostHelp':
    'यह फ़ोन अब इन फ़ोटो को पढ़ नहीं पा रहा (फ़ोन की स्टोरेज की खराबी)। टीम को बताएँ; रिकॉर्ड सर्वर पर पहुँच चुका है।',
  'sync.p.lostStrip': '{count} फ़ोटो इस फ़ोन में खो गए। कौन से, यह फ़ोटो में देखें।',
  'sync.p.lostCount': '{count} खोए',
  'sync.p.allSent': 'सारे फ़ोटो भेजे जा चुके हैं।',
  'sync.photos.title': 'भेजने बाकी फ़ोटो',
  'sync.photos.tries': '{count} बार कोशिश',
  'sync.photos.noError': 'अभी कोशिश नहीं हुई',
  'sync.photos.sendNow': 'फ़ोटो अभी भेजें',
  'sync.photos.sending': 'फ़ोटो भेज रहे हैं…',
  'sync.photos.result': '{sent} भेजे गए, {failed} नहीं गए',
  'outbox.SET_ASIDE': 'अलग रखा',
  'sync.statSetAside': 'अलग रखे',
  'sync.setAside': 'अलग रखें',
  'sync.putBack': 'वापस डालें',
  'sync.setAsideAsk':
    '“{what}” को कतार से हटाएँ ताकि बाकी काम भेजा जा सके। कुछ मिटेगा नहीं: यह इसी फ़ोन पर रहेगा और ऑफ़िस इसे सिंक समस्याओं में देखेगा।',
  'sync.setAsideChildren': 'इसके बाद के {count} काम इस पर टिके हैं, वे भी अलग रखे जाएँगे।',
  'sync.setAsideDone': '{count} अलग रखे',
  'sync.setAsideBy': '{name} ने अलग रखा, {when}',
  'sync.blocked': 'ऊपर वाली समस्या ठीक होने या अलग रखे जाने का इंतज़ार।',
  'sync.officeSees': 'ऑफ़िस इसे सिंक समस्याओं में देखता है।',
  'sync.why.PARENT_NEVER_ARRIVED':
    'दूसरे फ़ोन या पहले की एंट्री के डेटा का एक दिन से इंतज़ार है। उस फ़ोन को सिंक कराएँ। फिर भी रुका रहे तो सुपरवाइज़र इसे अलग रख सकता है।',
  'sync.why.WAIT_FOR_PARENT':
    'दूसरे फ़ोन या पहले की एंट्री के डेटा का इंतज़ार है। उस फ़ोन को सिंक कराएँ।',
  'sync.why.SESSION_CODE_TAKEN':
    'यह संग्रह दिवस कोड सर्वर पर पहले से इस्तेमाल हो चुका है। ऑफ़िस से पूछें।',
  'sync.why.UNKNOWN_VILLAGE': 'सर्वर इस गाँव को नहीं जानता। ऑफ़िस से फ़ोन का गाँव जाँचने को कहें।',
  'sync.why.ID_ALREADY_USED':
    'इस एंट्री की आईडी सर्वर पर किसी और रिकॉर्ड में लगी है। ऑफ़िस से पूछें।',
  'sync.why.SHIPMENT_CODE_TAKEN':
    'यह ट्रिप कोड सर्वर पर पहले से इस्तेमाल हो चुका है। ऑफ़िस से पूछें।',
  'sync.why.PAYLOAD_LOCKED':
    'यह एंट्री फ़ोन पर लॉक है और पढ़ी नहीं जा सकती। इसे अलग रखें और ऑफ़िस को बताएँ।',
  'sync.why.COMMAND_CONFLICT':
    'सर्वर के पास यह एंट्री अलग जानकारी के साथ पहले से है। ऑफ़िस से पूछें।',

  'nav.home': 'होम',
  'nav.sync': 'सिंक',
  'nav.more': 'और',
  'home.greeting': 'नमस्ते, {name}',
  'home.gate': 'संग्रह केंद्र',
  'home.store': 'स्टोर',

  'gate.openDay': 'संग्रह दिवस शुरू करें',
  'gate.openDayHint': 'तराज़ू जाँच, टैग रोल और सील',
  'gate.newDelivery': 'नई डिलीवरी',
  'gate.newDeliveryHint': 'किसान खोजें, जाँचें, टैग और तौल',
  'gate.closeDay': 'दिन बंद करें',
  'gate.closeDayHint': 'टैग और सील गिनें',

  'store.load': 'गाड़ी लोड',
  'store.loadHint': 'बोरियाँ स्कैन करके गाड़ी पर',
  'store.receive': 'माल प्राप्त',
  'store.receiveHint': 'गोदाम पर बोरियाँ स्कैन करके उतारें',
  'store.putAway': 'रखने की जगह',
  'store.putAwayHint': 'पहले जगह, फिर बोरियाँ स्कैन करें',
  'store.move': 'जगह बदलें',
  'store.moveHint': 'बोरियाँ दूसरी जगह ले जाएँ',
  'store.count': 'जगह गिनें',
  'store.countHint': 'बे की हर बोरी स्कैन करें',

  'scan.title': 'कोड स्कैन करें',
  'scan.tap': 'स्कैन के लिए दबाएँ',
  'scan.torchOn': 'टॉर्च चालू',
  'scan.torchOff': 'टॉर्च बंद',
  'scan.manual': 'कोड टाइप करें',
  'scan.manualHint': 'जब कैमरा टैग न पढ़ पाए तब।',
  'scan.noCamera': 'कैमरा नहीं मिला। कोड टाइप करें।',
  'scan.permission': 'स्कैन के लिए कैमरे की अनुमति दें।',
  'scan.use': 'यह कोड लें',

  'photo.take': 'फ़ोटो लें',
  'photo.retake': 'फिर से लें',
  'photo.saved': 'फ़ोटो फ़ोन में सेव',
  'photo.failed': 'फ़ोटो सेव नहीं हुई। फिर कोशिश करें।',

  'field.kg': 'किलो',
  'field.select': 'चुनें',
  'field.invalidKg': 'किलो 3 दशमलव तक डालें, जैसे 20.050',
}
